import { SxProps, Theme } from '@mui/material';

export const styles: Record<'dialog' | 'content', SxProps<Theme>> = {
  content: {
    padding: (theme) => theme.spacing(4.5, 4),
  },
  dialog: {
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    textAlign: 'center',
    width: (theme) => theme.breakpoints.values.md,
  },
};
